import React, {useContext, useState} from 'react'
import {Button, Col, Row} from "antd";
import {RecipeUpdateContext} from "../../../../context/RecipeUpdateContext";
import {updateRecipe} from "../../../../services/serviceRecipe";
import {enterLoadingState, exitLoadingState} from "../../../../utils/helpers/commonFunctions";

const UpdateAbstract = () => {

    const {byId, recipeTotal} = useContext(RecipeUpdateContext)
    const [recipeById] = byId
    const [loadings, setLoadings] = useState([])

    const handleSubmit = () => {
        enterLoadingState(setLoadings)

        let mockData = Object.assign({}, recipeById)

        let billOfMaterials = mockData.billOfMaterials.map(item => {
            return {
                ...item,
                lineTotal: (item.amount * item.parity * item.unitPrice)
            }
        })

        let recipe = {
            ...mockData.recipe,
            price: recipeTotal,
        }


        const requestObj = {
            billOfMaterials,
            recipe,
            recipeProductionCosts: mockData.recipeProductionCosts,
        }

        updateRecipe(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setTimeout(() => window.location = '/landing/recipe', 500)
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Row>
                <Col span={24}>
                    <h6> Reçete Adı : </h6>
                </Col>
                <Col span={24}>
                    <span>{recipeById.recipe.name}</span>
                </Col>
                <Col span={24}>
                    <h6> Reçete Kodu : </h6>
                </Col>
                <Col span={24}>
                    <span>{recipeById.recipe.code}</span>
                </Col>
                <Col span={24}>
                    <h6>Toplam :</h6>
                </Col>
                <Col span={24}>
                    {
                        <p><span>{new Intl.NumberFormat().format(recipeTotal)} USD</span></p>
                    }
                </Col>
            </Row>
            <Row justify={'end'}>
                <Col>
                    <Button type={'primary'} loading={loadings[0]} onClick={handleSubmit}>Kaydet</Button>
                </Col>
            </Row>
        </React.Fragment>
    )
}
export default UpdateAbstract